import React, { useEffect } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';

function ScorePage() {
  const location = useLocation();
  const navigate = useNavigate();
  const score = location.state?.score;
  const totalQuestions = 30;

  useEffect(() => {
    if (typeof score !== 'number') {
      navigate('/', { replace: true });
    }
  }, [score, navigate]);

  if (typeof score !== 'number') {
    return null;
  }

  const percentage = Math.round((score / totalQuestions) * 100);

  // Determine feedback based on score percentage
  const getFeedback = () => {
    if (percentage >= 80) {
      return {
        message: 'Uitstekend resultaat! Je bent goed voorbereid.',
        colorClass: 'text-correct',
      };
    } else if (percentage >= 50) {
      return {
        message: 'Een mooie basis. Blijf oefenen voor meer zekerheid.',
        colorClass: 'text-ink-light',
      };
    } else {
      return {
        message: 'Nog wat werk aan de winkel. Probeer het opnieuw!',
        colorClass: 'text-incorrect',
      };
    }
  };

  const feedback = getFeedback();

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center px-6 py-12 animate-fade-in">
      {/* Header Label */}
      <span className="font-body uppercase tracking-widest text-ink-muted text-sm mb-8">
        Jouw Resultaat
      </span>

      {/* Circular Percentage Indicator */}
      <div className="w-32 h-32 rounded-full border-4 border-accent flex items-center justify-center mb-8">
        <span className="font-display font-semibold text-3xl text-ink">
          {percentage}%
        </span>
      </div>

      {/* Large Score Display */}
      <p className="font-display text-6xl sm:text-7xl font-bold text-ink mb-6">
        {score}/{totalQuestions}
      </p>

      {/* Contextual Feedback Message */}
      <p className={`font-display italic text-lg ${feedback.colorClass} mb-12 text-center max-w-md`}>
        {feedback.message}
      </p>

      {/* CTA Button */}
      <Link to="/">
        <button className="bg-accent hover:bg-accent-dark text-white font-body font-semibold rounded-md px-8 py-3 transition-colors duration-200">
          Opnieuw oefenen
        </button>
      </Link>
    </div>
  );
}

export default ScorePage;
